import { RoutesPaths } from "../../../constants/routes.ts"
import type { GuideModule } from "../types/guide-content.types.ts"

// Order here drives both the Academy index and the default "Explore EZBuild"
// card grid on Guide Home. Only start-here and leads carry real lessons in
// this phase — the rest are declared so the framework, nav and role
// recommendations already have a full module list to point at, and ship
// with an honest "coming soon" rather than invented content.
export const GUIDE_MODULES: GuideModule[] = [
  {
    slug: "start-here",
    titleKey: "guide.modules.startHere.title",
    descriptionKey: "guide.modules.startHere.description",
    icon: "Home"
  },
  {
    slug: "leads",
    titleKey: "guide.modules.leads.title",
    descriptionKey: "guide.modules.leads.description",
    icon: "Leads",
    coreConceptKey: "guide.modules.leads.coreConcept",
    appRoute: RoutesPaths.lead.list
  },
  {
    slug: "projects",
    titleKey: "guide.modules.projects.title",
    descriptionKey: "guide.modules.projects.description",
    icon: "Projects",
    coreConceptKey: "guide.modules.projects.coreConcept",
    appRoute: RoutesPaths.project.grid
  },
  {
    slug: "finance",
    titleKey: "guide.modules.finance.title",
    descriptionKey: "guide.modules.finance.description",
    icon: "Dollar",
    coreConceptKey: "guide.modules.finance.coreConcept"
  },
  {
    slug: "files",
    titleKey: "guide.modules.files.title",
    descriptionKey: "guide.modules.files.description",
    icon: "Upload",
    coreConceptKey: "guide.modules.files.coreConcept"
  },
  {
    slug: "customers",
    titleKey: "guide.modules.customers.title",
    descriptionKey: "guide.modules.customers.description",
    icon: "Customers",
    coreConceptKey: "guide.modules.customers.coreConcept",
    appRoute: RoutesPaths.customers.list
  },
  {
    slug: "subcontractors",
    titleKey: "guide.modules.subcontractors.title",
    descriptionKey: "guide.modules.subcontractors.description",
    icon: "Subcontractors",
    coreConceptKey: "guide.modules.subcontractors.coreConcept",
    appRoute: RoutesPaths.subcontractors.list
  },
  {
    slug: "calendar",
    titleKey: "guide.modules.calendar.title",
    descriptionKey: "guide.modules.calendar.description",
    icon: "Calendar",
    appRoute: "/calendar"
  },
  {
    slug: "team-management",
    titleKey: "guide.modules.teamManagement.title",
    descriptionKey: "guide.modules.teamManagement.description",
    icon: "Users",
    appRoute: RoutesPaths.team_management
  },
  {
    slug: "suppliers",
    titleKey: "guide.modules.suppliers.title",
    descriptionKey: "guide.modules.suppliers.description",
    icon: "Office",
    appRoute: RoutesPaths.suppliers.list
  },
  {
    slug: "communication",
    titleKey: "guide.modules.communication.title",
    descriptionKey: "guide.modules.communication.description",
    icon: "Bell",
    appRoute: RoutesPaths.settings.notifications
  }
]

export const getGuideModule = (slug: string) =>
  GUIDE_MODULES.find((module) => module.slug === slug) ?? null
